'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recharts = require('recharts');

require('./chart-tooltip-wrapper.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartTooltip(_ref) {
  var renderTooltip = _ref.renderTooltip;

  return _react2.default.createElement(_recharts.Tooltip, {
    content: function content(tooltipProps) {
      if (!tooltipProps.payload || !tooltipProps.payload.length) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'chart-tooltip-wrapper' },
        renderTooltip(tooltipProps.payload[0])
      );
    }
  });
}

ChartTooltip.propTypes = {
  renderTooltip: _propTypes2.default.func
};

exports.default = ChartTooltip;